// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function GooglePlay({
  width = "28px",
  fill = "currentColor",
  ...props
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28.287 30.175"
      fill={fill}
      width={width}
      {...props}
    >
      <g transform="translate(0)">
        <g transform="translate(1.903 0)">
          <g transform="translate(0 0)">
            <path
              d="M52.042.483A3.831,3.831,0,0,0,48.3.492L62.05,13.174l4.618-4.618Z"
              transform="translate(-48.302 0)"
            />
          </g>
        </g>
        <g transform="translate(0 1.789)">
          <g transform="translate(0)">
            <path
              d="M16.542,30.365a3.517,3.517,0,0,0-.528,1.842V55.112a3.528,3.528,0,0,0,.492,1.8L30.331,43.085Z"
              transform="translate(-16.014 -30.365)"
            />
          </g>
        </g>
        <g transform="translate(17.036 9.504)">
          <path
            d="M314.457,163.708l-4.405-2.431-4.95,4.948,6.067,5.6L314.459,170a3.563,3.563,0,0,0,0-6.3Z"
            transform="translate(-305.102 -161.277)"
          />
        </g>
        <g transform="translate(1.841 15.788)">
          <g transform="translate(0)">
            <path
              d="M61.109,267.9,47.246,281.764a3.823,3.823,0,0,0,3.8.036l15.722-8.677Z"
              transform="translate(-47.246 -267.901)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Index/GooglePlay.js